import { render, staticRenderFns } from "./MappingListSimilar.vue?vue&type=template&id=35476d93&"
import script from "./MappingListSimilar.vue?vue&type=script&lang=js&"
export * from "./MappingListSimilar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListTile } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VListTile,VSubheader})
